import a04 from '@/components/parts/dials/dialA04';
import a05 from '@/components/parts/dials/dialA05';
import a06 from '@/components/parts/dials/dialA06';
import a22 from '@/components/parts/dials/dialA22';
import a36 from '@/components/parts/dials/dialA36';

export default {
  'A-04': a04,
  'A-05': a05,
  'A-06': a06,
  'A-22': a22,
  'A-36': a36,
};
